import { Fragment } from "react";
import CopyRight from "src/Components/Custom/CopyRight/CopyRight";
import Footer from "src/Components/Custom/Footer/Footer";
import NavBar from "src/Components/Custom/NavBar/NavBar";
import ContactUsContent from "./ContactUsContent";

function ContactUs() {
  return (
    <Fragment>
      <header>
        <NavBar />
      </header>
      <ContactUsContent />
      <Footer />
      <CopyRight />
    </Fragment>
  )
}
export default ContactUs;
